import React from "react";
import "../styles/Footer.css";
import instagramIcon from "../assets/icons/instagram.svg";
import linkedinIcon from "../assets/icons/linkedin.svg";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <h1 className="the-seasons-font" style={{ fontSize: "2.5rem" }}>
          Stay Connected
        </h1>
        <hr />
        <div className="footer-options-container">
          <div className="footer-options">
            <h3>PHONE</h3>
            <p>
              <a href="tel:+91 99127 54074">+91 99127 54074</a>
            </p>
          </div>
          <div className="footer-options">
            <h3>EMAIL</h3>
            <a href="mailto:info@bitsndspaceinteriors.gmail.com">
              info@bitsndspaceinteriors.com
            </a>
          </div>
          <div className="footer-options">
            <h3>LOCATION</h3>
            <a
              href="https://maps.app.goo.gl/ngbTdB88E3N2tBhH8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jubilee Hills, Hyderabad, Telangana
            </a>
          </div>
          <div className="footer-options">
            <h3>SOCIAL MEDIA</h3>
            <p>
              <a
                href="https://www.instagram.com/bitsn_dspaceinteriors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagramIcon} alt="Instagram" />
              </a>
              &nbsp; &nbsp;
              <a
                href="https://www.linkedin.com/company/bitsndspace-interiors/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>
            </p>
          </div>
        </div>
      </footer>
      <section className="credits the-seasons-font">
        © All rights reserved. Bits nd Space Interiors | Website by : &nbsp;
        <a
          href="https://www.linkedin.com/in/gautamjain0909"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit" }}
        >
          <b>Gautam Jain</b>
        </a>
      </section>
    </>
  );
};

export default Footer;
